import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../../data.service';

interface NaploSor {
  id: number; idopont: string; felhasznalo: string | null; valodi_felhasznalo: string | null;
  nezetvaltas_menet: string | null; modszer: string; utvonal: string; sablon: string | null;
  intezmeny: string | null; tanulo: string | null; ip: string | null; statusz: number; ido_ms: number | null;
  felhasznalo_nev: string | null; felhasznalo_szerep: string | null; valodi_nev: string | null; tanulo_nev: string | null;
}
interface Allapot {
  bekapcsolva: boolean; sorban: number; max_sor: number; megorzes_nap: number; eldobott: number; kiirt: number;
  hibak: number; utolsoHiba: string | null; utolsoHibaIdo: string | null; utolsoKiiras: string | null;
  figyelt_utvonalak: string[];
}

/**
 *  Admin → Hozzáférési napló (backend/hozzaferes-naplo.js), GDPR 32. cikk.
 *
 *  Ki, mikor, melyik személyes adatot kiszolgáló végpontot hívta: a token felhasználója, nézetváltásnál
 *  a valódi kérő is; az útvonal (lekérdezési paraméterek és kulcsok nélkül), a tanuló azonosítója, ha az
 *  útvonalból kiolvasható, az IP és a válasz státusza. Szűrés felhasználóra, tanulóra (azonosító vagy
 *  névrészlet), időszakra, útvonalra; lapozva. A napló maga is személyes adat – csak az `adatvedelem`
 *  területű admin éri el.
 */
@Component({
  selector: 'app-admin-hozzaferes-naplo',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './hozzaferes-naplo.component.html',
  styleUrls: ['./hozzaferes-naplo.component.scss'],
})
export class AdminHozzaferesNaploComponent implements OnInit {
  intezmeny = '';
  hiba = '';
  fut = false;
  betoltve = false;

  //  Szűrők – alapból az utolsó 7 nap.
  felhasznalo = '';
  tanulo = '';
  tol = '';
  ig = '';
  utvonal = '';
  modszer = '';
  statusz = '';
  csakNezetvaltas = false;

  sorok: NaploSor[] = [];
  osszes = 0;
  oldal = 1;
  meret = 50;
  allapot: Allapot | null = null;
  utvonalakNyitva = false;

  constructor(private http: HttpClient, private data: DataService) {}

  //  A tárolt intézményből (mint a többi admin-képernyő): közvetlen URL-betöltéskor az app-keret
  //  még nem regisztrált, és üres intézménnyel „nem admin" hibát kapnánk.
  async ngOnInit() {
    this.intezmeny = String((await this.data.getFromStorage('sajatIntezmeny'))?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    const nap = (d: Date) => d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Budapest' });
    const most = new Date();
    this.ig = nap(most);
    this.tol = nap(new Date(most.getTime() - 6 * 86400000));
    await this.betolt();
    this.allapotBetolt();
  }

  get oldalak() { return Math.max(1, Math.ceil(this.osszes / this.meret)); }

  async betolt(oldal = 1) {
    if (!this.intezmeny) { this.hiba = 'Nincs kiválasztott intézmény.'; return; }
    this.fut = true; this.hiba = '';
    try {
      let p = new HttpParams().set('oldal', String(oldal)).set('meret', String(this.meret));
      const be = (k: string, v: string) => { if (v && v.trim()) p = p.set(k, v.trim()); };
      be('felhasznalo', this.felhasznalo); be('tanulo', this.tanulo); be('tol', this.tol); be('ig', this.ig);
      be('utvonal', this.utvonal); be('modszer', this.modszer); be('statusz', this.statusz);
      if (this.csakNezetvaltas) p = p.set('nezetvaltas', '1');
      const r: any = await firstValueFrom(this.http.get(`/api/hozzaferes-naplo/lista/${this.intezmeny}`, { params: p }));
      this.sorok = r?.sorok || [];
      this.osszes = Number(r?.osszes) || 0;
      this.oldal = Number(r?.oldal) || oldal;
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A napló nem tölthető be.';
    } finally {
      this.fut = false; this.betoltve = true;
    }
  }

  async allapotBetolt() {
    try { this.allapot = await firstValueFrom(this.http.get<Allapot>(`/api/hozzaferes-naplo/allapot/${this.intezmeny}`)); }
    catch { this.allapot = null; }
  }

  szur() { this.betolt(1); }
  torol() {
    this.felhasznalo = ''; this.tanulo = ''; this.utvonal = ''; this.modszer = ''; this.statusz = ''; this.csakNezetvaltas = false;
    this.betolt(1);
  }
  lapoz(d: number) {
    const uj = Math.min(this.oldalak, Math.max(1, this.oldal + d));
    if (uj !== this.oldal) this.betolt(uj);
  }
  //  Egy cellára kattintva arra szűrünk (felhasználó / tanuló).
  szurFelhasznalo(f: string | null) { if (f) { this.felhasznalo = f; this.betolt(1); } }
  szurTanulo(t: string | null) { if (t) { this.tanulo = t; this.betolt(1); } }

  statuszOsztaly(s: number) { return !s ? 'hiba' : s >= 400 ? 'hiba' : s >= 300 ? 'atir' : 'ok'; }
}
